import z from "zod";

import { mapErrorsToFields } from "../../../../utils";
import GreetingOccasionSubcategoryService from "../../../../services/GreetingOccasionSubcategoryService";

const api = new GreetingOccasionSubcategoryService();
export type State = {
  message: string | null;
  errors?: {
    name?: string[];
    general?: string[];
  };
  success: boolean;
  defaultValues: {
    name?: string;
  };
};

const FormSchema = z.object({
  name: z.string().min(1, { message: "Name is required." }),
  greetingOccasionCategoryId: z.number(),
});

export async function createGreetingOccasionSubCategory(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() || "",
    greetingOccasionCategoryId: parseInt(formData.get("greetingOccasionCategoryId")?.toString() || "0"),
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to create greeting occasion category.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.createGreetingOccasionSubcategory(validatedFields.data);
    if (result.status === 201)
      return {
        errors: {},
        message: "Greeting Occasion Sub Category created successfully.",
        defaultValues,
        success: true,
      };
    else if (result.status === 400)
      return {
        errors: {},
        message: result.data.description,
        defaultValues,
        success: false,
      };
  } catch (error) {
    console.error("Error creating greeting sub occasion category:", error);
  }
  return {
    errors: {},
    message: "Failed to create greeting sub occasion category.",
    defaultValues,
    success: false,
  };
}

export async function updateGreetingOccasionSubCategory(
  id: number,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() || "",
    greetingOccasionCategoryId: parseInt(formData.get("greetingOccasionCategoryId")?.toString() || "0"),
  };
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);
    if (!validatedFields.success) {
      return {
        errors: mapErrorsToFields(validatedFields.error),
        message: "Failed to update greeting sub occasion category.",
        defaultValues,
        success: false,
      };
    }
    const result = await api.updateGreetingOccasionSubcategory({
      id: id,
      ...validatedFields.data,
    });
    if (result.status === 204)
      return {
        errors: {},
        message: "Greeting Occasion Sub Category updated successfully.",
        defaultValues,
        success: true,
      };
  } catch (error) {
    console.error("Error updating greeting sub occasion category:", error);
  }
  return {
    errors: {},
    message: "Failed to update greeting occasion sub category.",
    defaultValues,
    success: false,
  };
}

export async function deleteGreetingOccasionSubCategory(
  id: number
): Promise<{ success: boolean }> {
  try {
    const result = await api.deleteGreetingOccasionSubcategory(id);
    return { success: result.status === 204 };
  } catch (error) {
    console.error("Database Error:", error);
  }
  return { success: false };
}

